// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"2520710a","131":"4b974203","168":"e6740737","499":"9ff1d075","685":"6a1b2591"}[chunkId] + ".chunk.js";
};